import { render, staticRenderFns } from "./CatInfo.vue?vue&type=template&id=64e05699&scoped=true"
import script from "./CatInfo.vue?vue&type=script&lang=js"
export * from "./CatInfo.vue?vue&type=script&lang=js"
import style0 from "./CatInfo.vue?vue&type=style&index=0&id=64e05699&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e05699",
  null
  
)

export default component.exports